import { privateApi } from 'api'
import { AxiosResponse } from 'axios'
import { IAdLink, ICreateAdLink, IUpdateAdLink } from 'models/adLinks'
import {
  ICreateFeed,
  ICustomFeed,
  IFeedProduct,
  IFeedStats
} from 'models/feeds'
import {
  IBroadcastAudience,
  IBroadcastAudienceRequest,
  IBroadcastPreview,
  INotificationCampaign,
  ISendBroadcast,
  ITestBroadcast,
  ITestBroadcastResult
} from 'models/notifications'

export const actionsApi = {
  sendBroadcast(
    data: ISendBroadcast
  ): Promise<AxiosResponse<INotificationCampaign>> {
    return privateApi.post('notification/broadcast', data)
  },
  sendTestBroadcast(
    data: ITestBroadcast
  ): Promise<AxiosResponse<ITestBroadcastResult>> {
    return privateApi.post('notification/broadcast/test', data)
  },
  previewBroadcast(
    data: ISendBroadcast
  ): Promise<AxiosResponse<IBroadcastPreview>> {
    return privateApi.post('notification/broadcast/preview', data)
  },
  getBroadcastAudience(
    data: IBroadcastAudienceRequest
  ): Promise<AxiosResponse<IBroadcastAudience>> {
    return privateApi.post('notification/broadcast/audience', data)
  },
  getNotificationCampaigns(params: {
    skip: number
    limit: number
  }): Promise<
    AxiosResponse<{ items: INotificationCampaign[]; total: number }>
  > {
    return privateApi.get('notification/campaigns', { params })
  },
  getNotificationCampaign(
    campaignId: string
  ): Promise<AxiosResponse<INotificationCampaign>> {
    return privateApi.get(`notification/campaign/${campaignId}`)
  },
  repeatNotificationCampaign(
    campaignId: string
  ): Promise<AxiosResponse<INotificationCampaign>> {
    return privateApi.post(`notification/campaign/${campaignId}/repeat`)
  },
  cancelNotificationCampaign(
    campaignId: string
  ): Promise<AxiosResponse<{ ok: boolean }>> {
    return privateApi.post(`notification/campaign/${campaignId}/cancel`)
  },
  getFeedStats(): Promise<AxiosResponse<IFeedStats>> {
    return privateApi.get('feed-stats')
  },
  getFeeds(): Promise<AxiosResponse<ICustomFeed[]>> {
    return privateApi.get('admin/feeds')
  },
  createFeed(data: ICreateFeed): Promise<AxiosResponse<ICustomFeed>> {
    return privateApi.post('admin/feeds', data)
  },
  deleteFeed(id: string): Promise<AxiosResponse> {
    return privateApi.delete(`admin/feeds/${id}`)
  },
  getFeedProducts(id: string): Promise<AxiosResponse<IFeedProduct[]>> {
    return privateApi.get(`admin/feeds/${id}/products`)
  },
  getFeedSellerIds(): Promise<AxiosResponse<string[]>> {
    return privateApi.get('admin/feeds/sellers')
  },
  getFeedProductIds(): Promise<AxiosResponse<string[]>> {
    return privateApi.get('admin/feeds/product-ids')
  },
  getAdLinks(): Promise<AxiosResponse<IAdLink[]>> {
    return privateApi.get('admin/ad-links')
  },
  createAdLink(data: ICreateAdLink): Promise<AxiosResponse<IAdLink>> {
    return privateApi.post('admin/ad-links', data)
  },
  updateAdLink(id: string, data: IUpdateAdLink): Promise<AxiosResponse<IAdLink>> {
    return privateApi.patch(`admin/ad-links/${id}`, data)
  }
}
